export const Roles = Object.freeze({
  ADMIN:       'administrator',
  FINANCIAL:   'financial',
  COMPLIANCE:  'compliance',
  SUPPORT:     'support',
  ATTENDANT:   'attendant',
  COMMERCIAL:  'commercial',
})

export const RoleDescriptions = Object.freeze({
  [Roles.ADMIN]:       'Administra todas as configurações do sistema, gerencia acessos e parâmetros globais.',
  [Roles.FINANCIAL]:   'Executa atividades financeiras com amplo acesso a saques, reembolsos e dados de clientes.',
  [Roles.COMPLIANCE]:  'Visualiza informações de clientes, produtos e vendas para apoio comercial.',
  [Roles.SUPPORT]:     'Consulta informações de clientes e vendas para suporte básico ao atendimento.',
  [Roles.ATTENDANT]:   'Atua em reembolsos e suporte, com acesso a reclamações, produtos e cancelamentos.',
  [Roles.COMMERCIAL]:  'Planeja e executa estratégias de vendas, mantém relacionamento com clientes e analisa oportunidades de mercado.',
})

export function getRoles() {
  return [
    Roles.ADMIN,
    Roles.FINANCIAL,
    Roles.COMPLIANCE,
    Roles.SUPPORT,
    Roles.ATTENDANT,
    Roles.COMMERCIAL,
  ]
}
